import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewOne',
  templateUrl: './viewOne.component.html',
  styleUrls: ['./viewOne.component.css']
})
export class ViewOneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
